import { routes as brokerPortal } from "@pages/brokerPortal/brokerPortal.routes";
import { routes as customerPortal } from "@pages/customerPortal/customerPortal.routes";
import { routes as customerWeb } from "@pages/customerWeb/customerWeb.routes";

const getCustomerPortalInteriorPagesPaths = () => ["/account", "/broker"];

const routes = [...customerPortal, ...brokerPortal, ...customerWeb];

export { getCustomerPortalInteriorPagesPaths, routes };
